import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type ResolveDriverUserQueryVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
}>;


export type ResolveDriverUserQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', user_id?: number | null }> };


export const ResolveDriverUserDocument = gql`
    query ResolveDriverUser($driverId: bigint!) {
  drivers(where: {id: {_eq: $driverId}}) {
    user_id
  }
}
    `;

/**
 * __useResolveDriverUserQuery__
 *
 * To run a query within a React component, call `useResolveDriverUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveDriverUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveDriverUserQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useResolveDriverUserQuery(baseOptions: Apollo.QueryHookOptions<ResolveDriverUserQuery, ResolveDriverUserQueryVariables> & ({ variables: ResolveDriverUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>(ResolveDriverUserDocument, options);
      }
export function useResolveDriverUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>(ResolveDriverUserDocument, options);
        }
// @ts-ignore
export function useResolveDriverUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>;
export function useResolveDriverUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveDriverUserQuery | undefined, ResolveDriverUserQueryVariables>;
export function useResolveDriverUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>(ResolveDriverUserDocument, options);
        }
export type ResolveDriverUserQueryHookResult = ReturnType<typeof useResolveDriverUserQuery>;
export type ResolveDriverUserLazyQueryHookResult = ReturnType<typeof useResolveDriverUserLazyQuery>;
export type ResolveDriverUserSuspenseQueryHookResult = ReturnType<typeof useResolveDriverUserSuspenseQuery>;
export type ResolveDriverUserQueryResult = Apollo.QueryResult<ResolveDriverUserQuery, ResolveDriverUserQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/resolveDriverUser.query.gql}
 */
export async function resolveDriverUser(
  variables: ResolveDriverUserQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<ResolveDriverUserQuery['drivers']>
export async function resolveDriverUser(
  variables: ResolveDriverUserQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<ResolveDriverUserQuery>
export async function resolveDriverUser(
  variables: ResolveDriverUserQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<ResolveDriverUserQuery['drivers'] | ResolveDriverUserQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<ResolveDriverUserQuery>(
    ResolveDriverUserDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers
}